import { useRef, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div ref={ref} className="relative w-full max-w-xl">
      <button
        onClick={() => setOpen((o) => !o)}
        className="flex w-full items-center justify-between gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3 text-left text-foreground-800 cursor-pointer transition-colors hover:border-primary-300"
        aria-label={t('category.dropdownLabel')}
      >
        <span className="flex items-center gap-3">
          <span className="flex w-6 h-6 items-center justify-center text-primary-600">
            <i className="ri-grid-fill text-lg"></i>
          </span>
          <span className="text-sm font-medium whitespace-nowrap">{t('category.dropdownLabel')}</span>
        </span>
        <span className="flex w-5 h-5 items-center justify-center text-foreground-500">
          <i className={`ri-arrow-down-s-line text-lg transition-transform ${open ? 'rotate-180' : ''}`}></i>
        </span>
      </button>

      {open && (
        <div className="absolute left-0 right-0 mt-2 rounded-lg border border-background-200 bg-background-50 py-2 z-40 max-h-80 overflow-y-auto">
          {categories.map((cat) => (
            <a
              key={cat.key}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setOpen(false)}
              className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <span className="flex w-6 h-6 items-center justify-center text-primary-600">
                <i className={`${cat.icon} text-base`}></i>
              </span>
              {t(`cat.${cat.key}`)}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}